export const Profession = api => ({
  /**
   * Update profile profession
   *
   * @param slug: string
   * @param profession
   * @returns Promise
   */
  update(slug, profession) {
    return api.put(`/v1/profiles/${slug}/profession`, { profession })
  }
})
